import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client"; // Notice the new imports
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";

const container = document.getElementById("root");

// The Logic for SEO Prerendering
if (container.hasChildNodes()) {
  // 1. If we have pre-rendered HTML, "Hydrate" it
  hydrateRoot(
    container,
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  // 2. If it's a fresh load (development), "Create" the root normally
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
